import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; // Import Router, Routes, and Route
import { WishlistProvider } from './Projects/Context/WishlistContext';
import Index from './Projects/Index';  // Home Page
import Aboutus from './Projects/about/aboutus'; // About Page
import Customiseyourproject from './Projects/customiseyourproject/customiseyourproject';
import ArtShows from './Projects/artshows/ArtShows';
import Scrollfunctions from './Projects/Components/Scrollfunctions';
import Decorativedesc from './Projects/wallcoverings/naturedesc';
import Exclusivehanddescs from './Projects/exclusivehand/exclusivehanddescs';
import Nature from './Projects/wallcoverings/nature';
import ExclusiveHand from './Projects/exclusivehand/exclusivehand';
import Abstract from './Projects/wallcoverings/abstract';
import Abstractdesc from './Projects/wallcoverings/abstractdesc';
import ArtprintsAbstract from './Projects/artprints/abstract';
import ArtprintsAbstractdesc from './Projects/artprints/abstractdesc';
import ArtprintsExclusive from './Projects/artprints/exclusive';
import ArtprintsExclusivedesc from './Projects/artprints/exclusivedesc';
import ArtprintsLandscape from './Projects/artprints/landscape';
import ArtprintsLandscapedesc from './Projects/artprints/landscapedesc';
import ArtprintsViewAll from './Projects/artprints/viewall';
import ArtprintsViewAlldesc from './Projects/artprints/viewalldesc';
import WallcoveringCorporate from './Projects/wallcoverings/corporate';
import Corporatedesc from './Projects/wallcoverings/corporatedesc';
import WallcoveringKids from './Projects/wallcoverings/kids';
import Kidsdesc from './Projects/wallcoverings/kidsdesc';
import WallcoveringMinimalPattern from './Projects/wallcoverings/minimalpattern';
import MinimalPatterndesc from './Projects/wallcoverings/minimalpatterndesc';
import ArtprintsDecorative from './Projects/artprints/decorative';
import ArtprintsDecorativedesc from './Projects/artprints/decorativedesc';
import ArtprintsSt from './Projects/artprints/st';
import ArtprintsStdesc from './Projects/artprints/stdesc';
import WallcoveringViewAll from './Projects/wallcoverings/viewall';
import WallcoveringViewAlldesc from './Projects/wallcoverings/viewalldesc';
import AdminNewArrivals from './Projects/Pages/AdminNewArrivals';
import Wishlist from './Projects/Pages/Wishlist';
const App = () => {
  useEffect(() => {
    const block = (e) => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    };
  
    // Right click
    document.addEventListener("contextmenu", block, true);
  
    // Text selection & copy
    document.addEventListener("selectstart", block, true);
    document.addEventListener("copy", block, true);
  
    // Image drag
    document.addEventListener("dragstart", (e) => {
      if (e.target.tagName === "IMG") block(e);
    }, true);
  
    // DevTools shortcuts
    document.addEventListener("keydown", (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && ["I", "C", "J"].includes(e.key)) ||
        (e.ctrlKey && e.key === "U")
      ) {
        block(e);
      }
    }, true);
  
    return () => {
      document.removeEventListener("contextmenu", block, true);
      document.removeEventListener("selectstart", block, true);
      document.removeEventListener("copy", block, true);
    };
  }, []);
  
  return (
    <Router onContextMenu={(e) => e.preventDefault()}>
      <WishlistProvider>
        <div>
          <div className='z-50'><Scrollfunctions /></div>
          <Routes>
          {/* Route for the home page (Index component) */}
          <Route path="/" element={<Index />} />

          {/* Route for the about page */}
          <Route path="/aboutus" element={<Aboutus />} />


          {/* Route for Wallcoverings - nature section */}
          <Route path="/wallcoverings/decorative" element={<Nature />} />
          <Route path="/wallcoverings/decorative/desc/:id" element={<Decorativedesc />} /> {/* Add dynamic :id */}

          <Route path="/wallcoverings/abstract" element={<Abstract />} />
          <Route path="/wallcoverings/abstract/desc/:id" element={<Abstractdesc />} />




          {/* Route for Wallcoverings - corporate section */}
          <Route path="/wallcoverings/corporate" element={<WallcoveringCorporate />} />
          <Route path="/wallcoverings/corporate/desc/:id" element={<Corporatedesc />} />

          {/* Route for Wallcoverings - kids section */}
          <Route path="/wallcoverings/kids" element={<WallcoveringKids />} />
          <Route path="/wallcoverings/kids/desc/:id" element={<Kidsdesc />} />

          {/* Route for Wallcoverings - minimal and pattern section */}
          <Route path="/wallcoverings/minimal and pattern" element={<WallcoveringMinimalPattern />} />
          <Route path="/wallcoverings/minimal and pattern/desc/:id" element={<MinimalPatterndesc />} />
          <Route path="/wallcoverings/minimal-and-pattern" element={<WallcoveringMinimalPattern />} />
          <Route path="/wallcoverings/minimal-and-pattern/desc/:id" element={<MinimalPatterndesc />} />

          {/* Route for Wallcoverings - View All section */}
          <Route path="/wallcoverings" element={<WallcoveringViewAll />} />
          <Route path="/wallcoverings/desc/:id" element={<WallcoveringViewAlldesc />} />

            {/* Route for Artprints - View All section */}
          <Route path="/artprints" element={<ArtprintsViewAll />} />
          <Route path="/artprints/desc/:id" element={<ArtprintsViewAlldesc />} />

          {/* Route for Artprints - abstract section */}
          <Route path="/artprints/abstract" element={<ArtprintsAbstract />} />
          <Route path="/artprints/abstract/desc/:id" element={<ArtprintsAbstractdesc />} />


          {/* Route for Artprints - landscape section */}
          <Route path="/artprints/landscape" element={<ArtprintsLandscape />} />
          <Route path="/artprints/landscape/desc/:id" element={<ArtprintsLandscapedesc />} />

          {/* Route for Artprints - decorative section */}
          <Route path="/artprints/decorative" element={<ArtprintsDecorative />} />
          <Route path="/artprints/decorative/desc/:id" element={<ArtprintsDecorativedesc />} />

          {/* Route for Artprints - exclusive section */}
          <Route path="/artprints/exclusive" element={<ArtprintsExclusive />} />
          <Route path="/artprints/exclusive/desc/:id" element={<ArtprintsExclusivedesc />} />

          {/* Route for Artprints - st section */}
          <Route path="/artprints/set of 2 and 3" element={<ArtprintsSt />} />
          <Route path="/artprints/set of 2 and 3/desc/:id" element={<ArtprintsStdesc />} />




          {/* Route for Exclusive handpaintings */}
          <Route path="/exclusivehandpaintings" element={<ExclusiveHand />} />
          <Route path="/exclusivehand/desc/:id" element={<Exclusivehanddescs />} /> {/* Add dynamic :id */}

          {/* Route for Customise your project */}
          <Route path="/customiseyourproject" element={<Customiseyourproject />} />

          {/* Route for Art Shows */}
          <Route path="/artshows" element={<ArtShows />} />
          <Route path="/art-shows" element={<ArtShows />} />

          {/* Route for Admin - New Arrivals Management */}
          <Route path="/admin/new-arrivals" element={<AdminNewArrivals />} />

          {/* Route for Wishlist */}
          <Route path="/wishlist" element={<Wishlist />} />

        </Routes>
        {/* </Scrollfunctions> */}
        </div>
      </WishlistProvider>
    </Router>
  );
};

export default App;
